// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"a46b2635","1556":"a46b2635","5617":"b36648fc","7279":"a46b2635","7724":"a46b2635","9166":"a46b2635"}[chunkId] + ".chunk.css";
};